import { IsOptional } from "class-validator";
import { IAddress } from "./address.interface";

export class AddressDto implements IAddress {
  //
  @IsOptional()
  line1?: string;

  @IsOptional()
  line2?: string;

  @IsOptional()
  city?: string;

  @IsOptional()
  state?: string;

  @IsOptional()
  country?: string;

  @IsOptional()
  postal_code?: string;
}
